import styled from "styled-components";

export const PeakCartonCountContainer = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 1em 1.5em;
`;

export const VolumeByWeekGrid = styled("div")`
  display: grid;
  flex: 1;
  grid-template-rows: repeat(16, 1fr);
  grid-template-columns: repeat(8, 1fr);
  border-radius: 10px;
  background-color: #f0f2f5;
  width: 80%;
  grid-template-areas:
    "volumeByWeekHeader volumeByWeekHeader volumeByWeekHeader volumeByWeekHeader volumeByWeekHeader volumeByWeekHeader volumeByWeekHeader volumeByWeekHeader"
    "volumeByWeekHeader volumeByWeekHeader volumeByWeekHeader volumeByWeekHeader volumeByWeekHeader volumeByWeekHeader volumeByWeekHeader volumeByWeekHeader"
    "space1 space1 space1 space1 space1 space1 space1 space1"
    "lastYearActualOutbound lastYearActualOutbound lastYearActualOutbound lastYearActualOutbound lastYearActualOutbound lastYearActualOutbound lastYearActualOutbound lastYearActualOutbound"
    "space2 space2 space2 space2 space2 space2 space2 space2"
    "volume volume volume volume volume volume volume volume"
    "volume volume volume volume volume volume volume volume"
    "volume volume volume volume volume volume volume volume"
    "space3 space3 space3 space3 space3 space3 space3 space3"
    "budget budget budget budget budget budget budget budget"
    "budget budget budget budget budget budget budget budget"
    "budget budget budget budget budget budget budget budget"
    "space4 space4 space4 space4 space4 space4 space4 space4"
    "projection projection projection projection projection projection projection projection"
    "projection projection projection projection projection projection projection projection"
    "projection projection projection projection projection projection projection projection";
`;

export const HeaderContainer = styled("div")`
  display: flex;
  flex-direction: row;
  flex: 1;
`;

export const HeaderDateCell = styled("div")`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 1.07em;
`;

export const HeaderCellTitle = styled("div")`
  flex: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 1.1em;
  background-color: #f5f5f5;
`;

export const LastYearActualOutboundHeader = styled("div")`
  flex: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 1.1em;
  background-color: #f5f5f5;
`;

export const CenteredCell = styled("div")`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.13em;
`;

export const HeaderTitle = styled("div")`
  flex: 1.5;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 1.2em;
  background-color: #f5f5f5;
`;

export const SubHeaderContainer = styled("div")`
  display: flex;
  flex-direction: column;
  flex: 1.5;
  font-weight: bold;
  background-color: #f5f5f5;
`;

export const SubHeader = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 1.07em;
  background: ${(props) => (props.highlighted ? "#2196f377" : "initial")}
  flex: 1;
`;

export const FigureContainer = styled("div")`
  display: flex;
  flex-direction: column;
  flex: 5;
`;

export const FigureValue = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) => (props.highlighted ? "#2196f377" : "initial")}
  font-weight: ${(props) => (props.highlighted ? "bold" : "initial")}
  font-size: 1.13em;
  flex: 1;
`;

export const FigureRow = styled("div")`
  display: flex;
  flex-direction: row;
  flex: 1;
`;
